<template>
  <span v-if="!isLarge">{{ trimmedStr }}</span>
  <span v-else>{{ trimmedStr }}</span>
</template>
<script>
import { computed, defineComponent } from "vue";

export default defineComponent({
  props: {
    value: { type: [String, Number], default: null },
    limit: { default: 300, type: Number },
  },
  setup(props) {
    const stringValue = `${props.value}`
    const isLarge = computed(() => stringValue.length > props.limit);
    const str = computed(() =>
      isLarge.value ? `${stringValue.slice(0, props.limit)}...` : stringValue
    );

    const trimmedStr = computed(() => `${str.value}`.trim());

    return {
      trimmedStr,
      isLarge,
    };
  },
});
</script>
